module.exports = __webpack_public_path__ + "img/plan4_book07.9c499a72.png";